import VdPembelajaran from "@/modules/vd_pembelajaran/components/VdPembelajaran";
import VdPembelajaranForm from "@/modules/vd_pembelajaran/components/Form";
import VdPembelajaranReport from "@/modules/vd_pembelajaran/components/VideoReport";
import VideoReportDetail from "../components/VideoReportDetail.vue";

export default [
    {
        path: "/video",
        name: "VideoPembelajaran",
        component: VdPembelajaran,
    },
    {
        path: "/video/form",
        name: "VideoPembelajaranForm",
        component: VdPembelajaranForm,
    },
    {
        path: "/video/material/form",
        name: "VideoMaterial",
        component: VdPembelajaranForm,
    },
    {
        path: "/video/material/live-stream/form",
        name: "VideoMaterialLiveStream",
        component: VdPembelajaranForm,
    },
    {
        path: "/video/report",
        name: "VdPembelajaranReport",
        component: VdPembelajaranReport,
    },
    {
        path: "/video/report/detail",
        name: "VideoReportDetail",
        component: VideoReportDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/vd_pembelajaran/router/video.js